import { render, staticRenderFns } from "./regionSelect.vue?vue&type=template&id=b1122a10&scoped=true"
import script from "./regionSelect.vue?vue&type=script&lang=js"
export * from "./regionSelect.vue?vue&type=script&lang=js"
import style0 from "./regionSelect.vue?vue&type=style&index=0&id=b1122a10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1122a10",
  null
  
)

export default component.exports